import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'

//import { VueReCaptcha } from 'vue-recaptcha-v3'

// Components
import home from './components/home/home';
import customer from './components/products/customer/customer';
import chat from './components/products/chat/chat';
import analytics from './components/products/analytics/analytics';
import storage from './components/products/storage/storage';
import preferences from './components/products/preferences/preferences';
import integrations from './components/integrations/integrations';
import contact from './components/contact/contact';
import demo from './components/demo/demo';
import updateFeatures from './components/update-features/updateFeatures';
import terms from './components/terms/terms';
import privacy from './components/privacy/privacy';

Vue.config.productionTip = false
//Vue.use(VueReCaptcha, { siteKey: '6Lf4l9YUAAAAAOnWk4hWYuuvG6x6sD_zJowkvHtK' });
Vue.use(VueRouter)

const routes = [
	{ path: '/', name: 'page-home', component: home },
	{ path: '/customer', name: 'page-customer', component: customer },
	{ path: '/chat', name: 'page-chat', component: chat },
	{ path: '/analytics', name: 'page-analytics', component: analytics },
	{ path: '/storage', name: 'page-storage', component: storage },
	{ path: '/preferences', name: 'page-preferences', component: preferences },
	{ path: '/integrations', name: 'integrations', component: integrations },
	{ path: '/contact', name: 'contact', component: contact },
	{ path: '/demo', name: 'demo', component: demo },
	{ path: '/update-features', name: 'update-features', component: updateFeatures },
	{ path: '/terms-conditions', name: 'terms-conditions', component: terms },
	{ path: '/privacy', name: 'privacy', component: privacy }
]
const router = new VueRouter({
	mode: 'history',
	routes: routes,
	scrollBehavior (to, from, savedPosition) {
		console.log(to, from, savedPosition);
		return { x: 0, y: 0 };
	}
})

export const bus = new Vue();

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
